type ImageSignature = {
	mime: string;
	ext: string;
	magic: ReadonlyArray<{ offset: number; bytes: readonly number[] }>;
};

const IMAGE_SIGNATURES: readonly ImageSignature[] = [
	{ mime: 'image/jpeg', ext: 'jpg', magic: [{ offset: 0, bytes: [0xff, 0xd8, 0xff] }] },
	{ mime: 'image/png', ext: 'png', magic: [{ offset: 0, bytes: [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a] }] },
	// GIF87a or GIF89a
	{ mime: 'image/gif', ext: 'gif', magic: [{ offset: 0, bytes: [0x47, 0x49, 0x46, 0x38, 0x37, 0x61] }] },
	{ mime: 'image/gif', ext: 'gif', magic: [{ offset: 0, bytes: [0x47, 0x49, 0x46, 0x38, 0x39, 0x61] }] },
	{
		mime: 'image/webp',
		ext: 'webp',
		magic: [
			{ offset: 0, bytes: [0x52, 0x49, 0x46, 0x46] },
			{ offset: 8, bytes: [0x57, 0x45, 0x42, 0x50] },
		],
	},
];

function matchesAt(bytes: Uint8Array, offset: number, signature: readonly number[]): boolean {
	if (bytes.length < offset + signature.length) return false;
	return signature.every((byte, i) => bytes[offset + i] === byte);
}

export function detectImageMimeType(bytes: Uint8Array): { mime: string; ext: string } | null {
	const match = IMAGE_SIGNATURES.find(({ magic }) =>
		magic.every(({ offset, bytes: sig }) => matchesAt(bytes, offset, sig)),
	);
	return match ? { mime: match.mime, ext: match.ext } : null;
}
